<template>
  <div>
    <b-card no-body>
      <b-list-group v-if="hasItems" flush>
        <b-list-group-item
            v-for="disability in items"
            :key="`disability_${disability.id}`"
        >
          <disability-list-item :value="disability" />
        </b-list-group-item>
      </b-list-group>

      <transition appear name="loading-bar">
        <loading-bar v-show="pending" />
      </transition>
    </b-card>

    <no-results-found v-if="showNoResult" />

    <b-pagination
        v-if="showPagination"
        v-model="currentPage"
        :disabled="pending"
        :per-page="perPage"
        :total-rows="totalRows"
        align="center"
    />
  </div>
</template>

<script>
import DisabilityListItem from "@/components/disabilities/DisabilityListItem";
import fetchPaginatedData from "@/mixins/fetchPaginatedData";

export default {
  name: 'RoomDisabilities',
  components: {DisabilityListItem},
  mixins: [fetchPaginatedData],
  props: {
    roomId: {
      type: [String, Number],
      required: true,
    },
    status: {
      type: String,
      default: ''
    }
  },
  computed: {
    apiUrl() {
      return `/api/rooms/${this.roomId}/disabilities`;
    },
  },

  watch: {
    status: {
      handler(newValue) {
      this.$set(this.params, 'status', newValue);
    },
    immediate: true,
    }
  },

  created() {
    this.$root.$on('disabilities-assigned', () => this.fetchData)
  },
};
</script>
